import React from 'react';

const ClockIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10S6 21.523 6 16 10.477 6 16 6zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-.5 1.591a1 1 0 0 1 .993.883l.007.117-.001 5.227 3.181 1.768a1 1 0 0 1 .44 1.255l-.051.105a1 1 0 0 1-1.255.44l-.105-.052-4.209-2.34v-6.403a1 1 0 0 1 1-1z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);

export default ClockIcon;
